var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame5240(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2123_102075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 42C28 25.4315 41.4315 12 58 12C74.5685 12 88 25.4315 88 42C88 58.5685 74.5685 72 58 72C41.4315 72 28 58.5685 28 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6538 25.8462C50.7241 25.8462 47.5385 29.0318 47.5385 32.9615C47.5385 36.8913 50.7241 40.0769 54.6538 40.0769C58.5836 40.0769 61.7692 36.8913 61.7692 32.9615C61.7692 29.0318 58.5836 25.8462 54.6538 25.8462ZM48.9675 41.1417C43.1335 43.4173 39 49.0913 39 55.7308C39 56.5167 39.6371 57.1538 40.4231 57.1538C41.209 57.1538 41.8462 56.5167 41.8462 55.7308C41.8462 48.6573 47.5804 42.9231 54.6538 42.9231C60.1555 42.9231 64.6154 38.4631 64.6154 32.9615C64.6154 27.4599 60.1555 23 54.6538 23C49.1522 23 44.6923 27.4599 44.6923 32.9615C44.6923 36.3493 46.3834 39.3421 48.9675 41.1417Z",
    fill: "#9A4FE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8846 45.7692C69.6706 45.7692 70.3077 46.4064 70.3077 47.1923V51.4615H74.5769C75.3629 51.4615 76 52.0987 76 52.8846C76 53.6706 75.3629 54.3077 74.5769 54.3077H70.3077V58.5769C70.3077 59.3629 69.6706 60 68.8846 60C68.0987 60 67.4615 59.3629 67.4615 58.5769V54.3077H63.1923C62.4064 54.3077 61.7692 53.6706 61.7692 52.8846C61.7692 52.0987 62.4064 51.4615 63.1923 51.4615H67.4615V47.1923C67.4615 46.4064 68.0987 45.7692 68.8846 45.7692Z",
    fill: "#9A4FE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2123_102075",
    x: 0,
    y: 0,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2123_102075"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2123_102075"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2123_102075",
    result: "effect2_dropShadow_2123_102075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2123_102075",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame5240);
export default __webpack_public_path__ + "static/media/Frame5240.d09110fa2616f689a240f71a23e73ab1.svg";
export { ForwardRef as ReactComponent };